import {
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DehazeIcon from "@mui/icons-material/Dehaze";
import dayjs from "dayjs";
import DataPickerAtualizado from "../../../components/DataPickerAtualizado";
import "./styles.css";

export default function SelecionarVisualizacao({
  setSituacao,
  situacao,
  dataFim,
  setDataFim,
  onAdicionarAmostra,
  nomeUnidade,
  onAbrirModalUnidade,
}) {
  return (
    <div className="mapa-trace-filtros">
      <div className="mapa-trace-filtros-campos">
        <div className="mapa-trace-filtro-item">
          <DataPickerAtualizado
            data={dayjs(dataFim)}
            setData={setDataFim}
            variant="outlined"
            size="small"
            labelName="Data"
          />
        </div>
        <div className="mapa-trace-filtro-item mapa-trace-filtro-item--unidade">
          <FormControl id="unidade" variant="outlined" size="small" fullWidth>
            <InputLabel htmlFor="unidadeNome" shrink>
              Unidade
            </InputLabel>
            <OutlinedInput
              label="Unidade"
              value={nomeUnidade}
              readOnly
              onClick={onAbrirModalUnidade}
              inputProps={{ id: "unidadeNome" }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    id="unidadeOpen"
                    edge="end"
                    size="small"
                    tabIndex={-1}
                    aria-label="Selecionar unidade"
                    onClick={(e) => {
                      e.stopPropagation();
                      onAbrirModalUnidade();
                    }}
                  >
                    <DehazeIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
        <div className="mapa-trace-filtro-item">
          <FormControl size="small" variant="outlined" fullWidth>
            <InputLabel id="mapa-trace-situacao-label">Situação</InputLabel>
            <Select
              size="small"
              labelId="mapa-trace-situacao-label"
              id="novo-filtro-valor"
              label="Situação"
              value={situacao}
              onChange={(e) => setSituacao(e.target.value)}
            >
              <MenuItem value="pendente">Pendentes</MenuItem>
              <MenuItem value="concluido">Concluídos</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="mapa-trace-filtros-acao">
        <Button
          type="button"
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={onAdicionarAmostra}
          className="button-adicionar-amostra"
        >
          Adicionar Amostra
        </Button>
      </div>
    </div>
  );
}
